import { useEffect } from 'react';
import { ActivityIndicator, StyleSheet, Text, View } from 'react-native';
import { router } from 'expo-router';

import { useAuth } from '@/providers/auth-provider';

export default function AuthCallbackScreen() {
  const { loading, profile, session } = useAuth();

  useEffect(() => {
    if (loading) {
      return;
    }

    if (!session) {
      router.replace('/sign-in');
      return;
    }

    if (profile) {
      router.replace(`/${profile.role}`);
    }
  }, [loading, profile, session]);

  return (
    <View style={styles.screen}>
      <ActivityIndicator color="#173A2A" size="large" />
      <Text style={styles.title}>Signing you in...</Text>
      <Text style={styles.subtitle}>Restoring your MCQGen workspace.</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FBF7F0',
    paddingHorizontal: 24,
    gap: 12,
  },
  title: {
    color: '#173A2A',
    fontSize: 20,
    fontWeight: '700',
  },
  subtitle: {
    color: '#5D7162',
    fontSize: 14,
  },
});
